<div class="group-analysis-page">
  <div class="analysis-layout">
    <main class="analysis-content">

      <section #reportContent class="report-export-container">

        <div class="report-export-header">
          <h1 class="report-export-title">
            {{ selectedTemplate()?.name ?? "Group Analysis" }}
          </h1>

          <div class="report-export-date">
            {{ formatDisplayDate(startDate()) }}
            -
            {{ formatDisplayDate(endDate()) }}
          </div>
        </div>

        @if (loadingDashboard()) {
          <div class="dashboard-loading">
            กำลังโหลดข้อมูล...
          </div>
        } @else {

          <!-- Row 1 -->
          <section class="dashboard-grid dashboard-grid--top">

            <app-customer-site-card
              class="dashboard-site"
              [site]="customerSite()"
            />

            <lib-mdb-power-chart
              class="dashboard-power"
              [categories]="mdbPowerCategories()"
              [series]="mdbPowerSeries()"
            />

          </section>


          <!-- Row 2 -->
          <section class="dashboard-grid dashboard-grid--middle">

            <div class="energy-summary-list">
              <lib-energy-summary-card
                title="Energy Today"
                [scope]="'ALL ' + dailyEnergyPieChart().length + ' MDBs'"
                [energyValue]="totaldailyEnergyPieChart()"
                energyUnit="kWh"
                [carbonValue]="dailyCarbonEmission()"
                carbonUnit="tCO₂e"
                [comparison]="dailyComparisonText()"
                [comparisonValue]="dailyComparison()"
                comparisonLabel="vs. yesterday"
                theme="blue"
              />

              <lib-energy-summary-card
                title="Energy This Month"
                [scope]="'ALL ' + monthlyEnergyPieChart().length + ' MDBs'"
                [energyValue]="totalmonthlyEnergyPieChart()"
                energyUnit="kWh"
                [carbonValue]="monthlyCarbonEmission()"
                carbonUnit="tCO₂e"
                [comparison]="monthlyComparisonText()"
                [comparisonValue]="monthlyComparison()"
                comparisonLabel="vs. last month"
                theme="green"
              />
            </div>

            <lib-energy-summary
              class="dashboard-summary-table"
              [items]="monthlyEnergyPieChart()"
              [totalEnergy]="totalmonthlyEnergyPieChart()"
              [unit]="unit()"
            />

          </section>


          <!-- Row 3 -->
          <section class="dashboard-grid dashboard-grid--bottom">

            <lib-daily-energy-chart
              class="dashboard-daily-chart"
              [categories]="dailyCategories()"
              [series]="dailySeries()"
              [period]="dailyEnergyPeriod()"
              (periodChange)="onDailyEnergyPeriodChange($event)"
            />

            <lib-energy-distribution
              class="dashboard-distribution dashboard-distribution--today"
              title="Energy Consumption Distribution (Today)"
              [items]="dailyEnergyPieChart()"
            />

            <lib-energy-distribution
              class="dashboard-distribution dashboard-distribution--month"
              title="Energy Consumption Distribution (This Month)"
              [items]="monthlyEnergyPieChart()"
            />

          </section>

        }
      </section>

    </main>
  </div>
</div>